module.exports = __webpack_public_path__ + "media/sales/marker-line-de6265e8.png";